import { Modifier, Entity, EditorState } from 'draft-js'
import { createPlugin, pluginUtils } from 'draft-extend'
import { connect } from 'react-redux'
import IconSVG from 'svg-inline-react'
import { bindActionCreators } from 'redux'
import { withProps, withHandlers, compose, withState } from 'recompose'
import TetherComponent from 'react-tether'
import cx from 'classnames'
import onClickOutside from 'react-onclickoutside-decorator'

import { Tag } from '@driftt/tide-core-legacy'
import Avatar from 'shared-web/src/components/Avatar'

import { getUserDisplayName } from 'app/modules/user/utils'
import * as MeetingSelectors from 'app/modules/meetings/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as ProfileActions from 'app/modules/profile/actions'
import * as ResourcesConstants from 'constants/ResourcesConstants'

import calendarCheckSrc from '!svg-inline?removeTags=true!images/svg/calendar-check.svg'
import femalePlaceholderSrc from '!svg-inline?removeTags=true!images/svg/female-placeholder.svg'
import team2Src from '!svg-inline?removeTags=true!images/svg/team-2.svg'

import './style.styl'

const CalendarPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm',
}

const DYNAMIC_CALENDAR = 'DYNAMIC_CALENDAR'
const ENTITY_TYPE = 'LINK'


const getCalendarLink = (user) => {
  if (user === DYNAMIC_CALENDAR) {
    return '{{ sender.profile_schedule_url }}'
  } else {
    return `https://${ResourcesConstants.PROFILE_DOMAIN}/${user.getIn(['profile', 'globalHandle'])}/meeting`
  }

}

const insertCalendar = (linkText, link, editorState, pushChange = () => {}) => {
  const contentState = Modifier.insertText(
    editorState.getCurrentContent(),
    editorState.getSelection(),
    linkText,
    null,
    Entity.create(
      ENTITY_TYPE,
      'MUTABLE',
      {
        href: link,
        target: '_blank'
      }
    )
  )
  pushChange(
    EditorState.push(
      editorState,
      contentState,
      'insert-characters'
    )
  )
}


class CalendarPopoverSelect extends React.Component {
  render() {
    const { 
      usersWithCalendar,
      usersWithoutCalendar,
      search,
      onSearchChange,
      onPropertySelect,
      currentUser,
      currentUserHasCalendarConnected,
      enableDynamicCalendarLink,
      showCurrentUser,
      isSearching 
    } = this.props

    return (
      <div className="popover-selector-container">
        <div className="popover-selector-section popover-selector-section-top drift-form">
          <input
            className="popover-selector-search-input"
            type="text"
            value={search}
            onChange={onSearchChange}
            placeholder="Search"
          />
        </div>
        <div className="rich-editor-calendar-popover-options">
          {!!enableDynamicCalendarLink && !isSearching &&
            <div
              className={cx('rich-editor-calendar-popover-option')}
              onClick={() => onPropertySelect(DYNAMIC_CALENDAR)}
            >
              <div className="rich-editor-calendar-dynamic-option-icon">
                <IconSVG src={team2Src} />
              </div>
              <span className="rich-editor-calendar-popover-option-name">Dynamic based on email sender</span>
            </div>
          }
          {showCurrentUser &&
            <div
              className={cx('rich-editor-calendar-popover-option', { 'rich-editor-calendar-popover-option-disabled': !currentUserHasCalendarConnected })}
              onClick={() => currentUserHasCalendarConnected ? onPropertySelect(currentUser) : null}
            >
              <Avatar size="small" user={currentUser} />
              <span className="rich-editor-calendar-popover-option-name">{getUserDisplayName(currentUser)}</span>
              {!currentUserHasCalendarConnected &&
                <a
                  href="/meetings/?source=email-playbook-editor"
                  className="link dsg-Regular"
                >
                  Connect your calendar
                </a>

              }
            </div>
          }
          {usersWithCalendar
            .map((user) => (
              <div
                key={user}
                className="rich-editor-calendar-popover-option"
                onClick={() => onPropertySelect(user)}
              >
                <Avatar size="small" user={user} />
                <span className="rich-editor-calendar-popover-option-name">{getUserDisplayName(user)}</span>
              </div>
            ))
          }
          {usersWithoutCalendar.size > 0 &&
            <div className="rich-editor-calendar-popover-options-header">These calendars are not connected.</div>
          }
          {usersWithoutCalendar
            .map((user) => (
              <div
                key={user}
                className="rich-editor-calendar-popover-option rich-editor-calendar-popover-option-disabled"
              >
                <Avatar size="small" user={user} />
                <span className="rich-editor-calendar-popover-option-name">{getUserDisplayName(user)}</span>
              </div>
            ))
          }
          {usersWithoutCalendar.size === 0 &&
          usersWithCalendar.size === 0 &&
          !showCurrentUser &&
            <div className="popover-calendar-selector-empty-options">
              <IconSVG src={femalePlaceholderSrc} />
              <p>There is no one on your team by that name.</p>
            </div>
          }
        </div>
      </div>
    )
  }
}


const CalendarPopoverConfirm = ({
  onDefaultCancel,
  onDefaultConfirm,
  selectedUser,
  linkText,
  onDefaultChange,
  calendarProfileLoading,
}) =>
  <div className="popover-selector-container">
    <div className="popover-selector-section popover-selector-section-top">
      <div>
        {selectedUser === DYNAMIC_CALENDAR &&
          <div className="popover-selector-user-preview">
            <span className="popover-selector-user-preview-name">Dynamic based on email sender</span>
          </div>
        }
        {selectedUser !== DYNAMIC_CALENDAR &&
          <div className="popover-selector-user-preview">
            <Avatar size="small" user={selectedUser} />
            <span className="popover-selector-user-preview-name">{getUserDisplayName(selectedUser)}</span>
          </div>
        }
      </div>
      <div onClick={onDefaultCancel} className="link">Back</div>
    </div>
    <div className="drift-form popover-calendar-confirm-form">
      <label className="default-form-label">Link text:</label>
      <input type="text" value={linkText} onChange={onDefaultChange} />
      <p className="default-form-extra-details">Default values display when a contact doesn‘t have a value for this variable</p>
    </div>

    <div className="popover-selector-section">
      <div onClick={onDefaultCancel} className="popover-selector-section-button drift-button drift-button-secondary">Cancel</div>
      <div onClick={onDefaultConfirm} disabled={!!calendarProfileLoading} className="popover-selector-section-button drift-button drift-button-primary">Insert</div>
    </div>
  </div>


const CalendarPopover = (props) =>
  <div className={cx("rich-editor-calendar-popover", { 'rich-editor-popover-bottom-anchor': !!props.popoverAnchorBottom })}>
    {props.popoverStep === CalendarPopoverSteps.SELECT &&
      <CalendarPopoverSelect {...props} />
    }
    {props.popoverStep === CalendarPopoverSteps.CONFIRM &&
      <CalendarPopoverConfirm {...props} />
    }
  </div>


const CalendarButton = (props) =>
  <TetherComponent
    attachment="top left"
    targetAttachment="top right"
    targetOffset="0 10px"
    constraints={[{ to: 'scrollParent', attachment: 'together' }]}
  >
    <div className="rich-editor-calendar-button-container">
      <div
        className={cx('rich-editor-calendar-button', 'rich-editor-toolbar-button', { active: props.popoverOpen })}
        onClick={props.togglePopoverOpen}
      >
        <IconSVG src={calendarCheckSrc} className="rich-editor-toolbar-button-icon"/>
        <span>Calendar Link</span>
      </div>
      {props.popoverOpen &&
        <CalendarPopover
          {...props}
        />
      }
    </div>
  </TetherComponent>


const mapStateToProps = state => ({
  orgUsersById: UserSelectors.nonBotOrgUsersAlphabetical(state).toList(),
  currentUser: UserSelectors.currentUser(state),
  calendarConnectedAgentIds: MeetingSelectors.getAgentIdsWithConnectedCalendars(state),
  calendarProfileLoading: PlaybookSelectors.calendarProfileLoading(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchUserProfile: ProfileActions.fetchUserProfile,
    },
    dispatch
  ),
})

const CalendarButtonContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedUser', 'setSelectedUser', undefined),
  withState('popoverStep', 'setPopoverStep', CalendarPopoverSteps.SELECT),
  withState('popoverOpen', 'setPopoverOpen', false),
  withState('search', 'setSearch', ''),
  withState('linkText', 'setLinkText', 'Schedule a meeting'),
  withProps(props => {
    const usersWithoutCalendar = props.orgUsersById.filter(user => !props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id'))
    const usersWithCalendar = props.orgUsersById.filter(user => props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id'))
    if (!props.search) {
      return {
        usersWithoutCalendar,
        usersWithCalendar,
        currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
        showCurrentUser: true,
        isSearching: false,
      }
    } else {
      const withCalFiltered = usersWithCalendar.filter(user => {
        return getUserDisplayName(user).toLowerCase().includes(props.search.toLowerCase())
      })
      const withoutCalFiltered = usersWithoutCalendar.filter(user => {
        return getUserDisplayName(user).toLowerCase().includes(props.search.toLowerCase())
      })
      const showCurrentUser = props.currentUser && (!!props.search && getUserDisplayName(props.currentUser).toLowerCase().includes(props.search.toLowerCase()))
      return {
        usersWithoutCalendar: withoutCalFiltered,
        usersWithCalendar:  withCalFiltered,
        currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
        showCurrentUser,
        isSearching: true,
      }
    }
  }),
  withHandlers({
    onPropertySelect: props => (user) => {
      props.setSelectedUser(user)
      if (user !== DYNAMIC_CALENDAR) {
        props.actions.fetchUserProfile(user.get('id'))
      }
      props.setPopoverStep(CalendarPopoverSteps.CONFIRM)
    },
    onDefaultConfirm: props => () => {
      props.setPopoverStep(CalendarPopoverSteps.SELECT)
      // the select value (user) that's being passed around hasn't been hydrated with the profile info, so we're going to get the user from the store
      let selectedUser = props.selectedUser
      if (selectedUser !== DYNAMIC_CALENDAR) {
        selectedUser = props.orgUsersById.filter(user => user.get('id') === props.selectedUser.get('id')).first()
      }
      insertCalendar(props.linkText, getCalendarLink(selectedUser), props.editorState, props.onChange)
      props.setPopoverOpen(false)
    },
    onDefaultCancel: props => () => {
      props.setSelectedUser(undefined)
      props.setLinkText('Schedule a meeting')
      props.setPopoverStep(CalendarPopoverSteps.SELECT)
    },
    togglePopoverOpen: props => () => {
      props.setPopoverOpen(!props.popoverOpen)
    },
    onSearchChange: props => event => {
      props.setSearch(event.target.value)
    },
    onDefaultChange: props => event => {
      // make sure to escape double quotes
      props.setLinkText(event.target.value)
    },
    onClickOutside: props => () => {
      props.setPopoverOpen(false)
    },
  }),
  onClickOutside,
)(CalendarButton)

const CalendarDecorator = {
  strategy: pluginUtils.entityStrategy(ENTITY_TYPE),
  component: (props) => <Tag className="rich-editor-calendar" tag={{ name: props.children }}/>,
}


const htmlToEntity = (nodeName, node) => {
  if (nodeName === 'a') {
    return Entity.create(
      ENTITY_TYPE,
      'MUTABLE',
      {
        href: node.getAttribute('href'),
        target: node.getAttribute('target')
      }
    )
  }
}


const entityToHTML = (entity, originalText) => {
  if (entity.type === ENTITY_TYPE) {
    return `<a href="${entity.data.href}" target="${entity.data.target}">${originalText}</a>`
  }
  return originalText
}


export default createPlugin({
  decorators: CalendarDecorator,
  buttons: CalendarButtonContainer,
  htmlToEntity,
  entityToHTML,
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/plugins/calendar/index.js